export function initGiwlDecisionPage() {
    $(window).load(function () {
        if ($("#policyNumber").val() > 0) {
            aaalife.data.user.PCIN = $("#policyNumber").val();
            dataLayer.push({ user: aaalife.data.user });
        }
    });
}
